<template>
	<div class="beginning-stage">
		<div class="main-column">
			<div class="content sole-serif">
				<div class="header">
					<h1 class="text-center rotunda-veneta">Life Beware Herald</h1>
					
					<hr>
					
					<div class="date">{{date}}</div>
				</div>
				
				<hr>
				
				<div class="message text-center">
					<div v-if="superuser">
						Qui puoi vedere lo stato iniziale del gioco. Lascia qualche minuto ai giocatori per comprendere le statistiche, poi premi <strong class="red-txt">CONTINUA</strong> per passare all’attività successiva e iniziare la partita.
					</div>
					
					<div v-else class="medium-font sole-serif">
						<div class="small-row-padding">Benvenuti a Life Beware Valley</div>
						<hr>
						<div>Per dimezzare l’impatto dei disastri dobbiamo <strong>ridurre il rischio idraulico al 50%!</strong></div>
						<hr>
						<div>I <strong>servizi ecosistemici</strong> hanno un impatto sul <strong>benessere dei cittadini</strong> e sulle <strong>risorse a lungo termine</strong>.</div>
						<hr>
						<div>Le <strong>risorse a lungo termine</strong> generano <strong>risorse economiche</strong>.</div>
					</div>
				</div>
				
				<hr>
				
				<boards/>
				
				<div v-if="superuser" class="message text-center">
					<div class="button arrow" :class="{loading : advancing_phase}" @click="advancePhase">Continua</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Boards from '@/components/Boards.vue'
	import { helperMixin } from '@/store/helper.js';
	import { gameMixin } from '@/store/game_mixin.js';

	export default {
		name: 'Beginning',
		mixins : [helperMixin, gameMixin],
		components: {
			Boards
		},
	}
</script>	

<style lang="scss">
	
</style>